export default [
    {
      value: 10,
      text: "VISA",
    },
    {
      value: 20,
      text: "MasterCard",
    },
    {
      value: 30,
      text: "American Express",
    },
    {
      value: 40,
      text: "Discover",
    },
  ]


// WEBPACK FOOTER //
// ./src/config/paymentCardType.js